import { API_BASE_URL } from "./env";

export const API_ENDPOINTS = {
    getEvChargingStations: `${API_BASE_URL}/api/get-ev-charging-stations/`,
    getUtilityRates: `${API_BASE_URL}/api/utility-rates/`,
    getUtilityRatesByUtility: `${API_BASE_URL}/api/utility-rates/by-utility/`,
    getUtilityRateUtilities: `${API_BASE_URL}/api/utility-rates/utilities/`,
    getUtilityRateByTerritory: `${API_BASE_URL}/api/utility-rates/by-territory/`,
    getUtilityRatesByTerritory: `${API_BASE_URL}/api/utility-rates/by-territory/rates/`,
    getUtilityTerritoryRateMapping: `${API_BASE_URL}/api/utility-territory-rate-mapping/`,
    getUtilityServiceTerritories: `${API_BASE_URL}/api/utility-service-territories/`,
    getUtilityServiceTerritoryStates: `${API_BASE_URL}/api/utility-service-territories/states/`,
    getNyCensusTracts: `${API_BASE_URL}/api/ny-census-tracts/`,
    getNyBlockGroups: `${API_BASE_URL}/api/ny-block-groups/`,
    getNyZipCodes: `${API_BASE_URL}/api/ny-zip-codes/`,
    stopChainSimulation: `${API_BASE_URL}/api/stop-chain-simulation/`,
    stopChainSimulationLegacyBenchmark: `${API_BASE_URL}/api/stop-chain-simulation/legacy-benchmark/`,
    stopChainSimulationLegacyRustPointer: `${API_BASE_URL}/api/stop-chain-simulation/legacy-rust-pointer/`,
    getStopChainUtilityRegions: `${API_BASE_URL}/api/stop-chain-simulation/utility-regions/`,
    getStopChainUtilityBoundary: `${API_BASE_URL}/api/stop-chain-simulation/utility-boundary/`,
    getMdhdForecastUtilityRegions: `${API_BASE_URL}/api/stop-chain-simulation/mdhd-forecast-utility-regions/`,
    getMdhdForecastCurves: `${API_BASE_URL}/api/stop-chain-simulation/mdhd-forecast-curves/`,
    getDefaultTouUtilityNames: `${API_BASE_URL}/api/stop-chain-simulation/default-tou-utility-names/`,
    getWeatherDiagnostics: `${API_BASE_URL}/api/stop-chain-simulation/weather-diagnostics/`,
    mdhdAnalysisCases: `${API_BASE_URL}/api/mdhd-analysis-cases/`,
    mdhdAnalysisCaseHexProfile: (caseId) => `${API_BASE_URL}/api/mdhd-analysis-cases/${caseId}/hex-profile/`,
    mdhdAnalysisCaseUtilityProfile: (caseId) => `${API_BASE_URL}/api/mdhd-analysis-cases/${caseId}/utility-profile/`,
    mdhdAnalysisCaseStopProfiles: (caseId) => `${API_BASE_URL}/api/mdhd-analysis-cases/${caseId}/stop-profiles/`,
    mdhdAnalysisCaseStopProfileDetail: (caseId, profileId) => `${API_BASE_URL}/api/mdhd-analysis-cases/${caseId}/stop-profiles/${profileId}/`,
    mdhdAnalysisCaseEpriValidation: (caseId) => `${API_BASE_URL}/api/mdhd-analysis-cases/${caseId}/epri-validation/`,
    vectorTiles: {
        usCensusTracts: `${API_BASE_URL}/api/tiles/us-census-tracts/{z}/{x}/{y}.pbf`,
        usBlockGroups: `${API_BASE_URL}/api/tiles/us-block-groups/{z}/{x}/{y}.pbf`,
        usZipCodes: `${API_BASE_URL}/api/tiles/us-zip-codes/{z}/{x}/{y}.pbf`,
        utilityOverlapCensusTracts: `${API_BASE_URL}/api/tiles/utility-overlap-census-tracts/{z}/{x}/{y}.pbf`,
        utilityOverlapBlockGroups: `${API_BASE_URL}/api/tiles/utility-overlap-block-groups/{z}/{x}/{y}.pbf`,
        utilityOverlapZipCodes: `${API_BASE_URL}/api/tiles/utility-overlap-zip-codes/{z}/{x}/{y}.pbf`,
        nyH3Hexagons: `${API_BASE_URL}/api/tiles/ny-h3-hexagons/{z}/{x}/{y}.pbf`,
        centralHudsonDcChargers: `${API_BASE_URL}/api/tiles/central-hudson-dc-chargers/{z}/{x}/{y}.pbf`,
        centralHudsonLevel2Chargers: `${API_BASE_URL}/api/tiles/central-hudson-level2-chargers/{z}/{x}/{y}.pbf`,
        centralHudsonSubstations: `${API_BASE_URL}/api/tiles/central-hudson-substations/{z}/{x}/{y}.pbf`,
        centralHudsonSummer3Phase: `${API_BASE_URL}/api/tiles/central-hudson-summer-3phase/{z}/{x}/{y}.pbf`,
        mdhdCaseHex: (caseId) => `${API_BASE_URL}/api/tiles/mdhd-case-hex/${caseId}/{z}/{x}/{y}.pbf`,
    },

    // CA Statewide Case endpoints — lookup by case_name (preferred) or case_id (fallback)
    caStatewiseCase: `${API_BASE_URL}/api/ca-statewide/`,
    caStatewiseCaseHexData: `${API_BASE_URL}/api/ca-statewide/hex-data/`,
    caStatewiseCaseHexProfile: `${API_BASE_URL}/api/ca-statewide/hex-profile/`,
    caTransitCase: `${API_BASE_URL}/api/ca-transit/`,
    caTransitCaseHexData: `${API_BASE_URL}/api/ca-transit/hex-data/`,
    caTransitCaseHexProfile: `${API_BASE_URL}/api/ca-transit/hex-profile/`,
};